export default __webpack_public_path__ + "static/media/common-application-icon.4d4eb7ee.svg";